import React from "react";
import { Helmet } from "react-helmet";
import logo1 from "../../../assets/logo1.png";
import logo2 from "../../../assets/logo2.png";
import logo3 from "../../../assets/logo3.png";
import logo4 from "../../../assets/logo4.png";

const DISCORD_INVITE_URL = "https://discord.gg/8WF9QQJsVz";

export default function Discord() {
  return (
    <div className="discord-landing">
      <Helmet>
        <title>Discord | Pogforts</title>
        <meta
          name="description"
          content="Discover the Pogforts Discord community: houses, games, music and Magical Sorting Bat. Join the world's most dangerous Discord."
        />
        <link rel="canonical" href="https://pogforts.uk/discord" />
      </Helmet>

      <section className="discord-hero" aria-labelledby="discord-title">
        <div className="discord-brand-marks" aria-hidden="true">
          {[logo1, logo2, logo3, logo4].map((logo, index) => (
            <img key={index} src={logo} alt="" />
          ))}
        </div>
        <p className="discord-eyebrow">The community behind the ecosystem</p>
        <h1 id="discord-title">POGFORTS</h1>
        <p className="discord-tagline">The World&apos;s Most Dangerous Discord.</p>
        <p className="discord-intro">
          Your house. Your people. Your next move. Step into the Pogforts
          Discord community, where games, music and conversation bring
          the ecosystem to life.
        </p>
        <a
          className="discord-join-button"
          href={DISCORD_INVITE_URL}
          target="_blank"
          rel="noopener noreferrer"
        >
          Join Pogforts Discord <span aria-hidden="true">↗</span>
        </a>
        <p className="discord-link-note">Opens the Discord invite in a new tab.</p>
      </section>

      <section className="discord-features" aria-label="Explore the community">
        <article className="discord-feature">
          <span className="discord-feature-number" aria-hidden="true">01 / COMMUNITY</span>
          <h2>Find your house</h2>
          <p>
            Get sorted, meet the community and represent your house.
            Bring your personality and build your place in Pogforts.
          </p>
        </article>
        <article className="discord-feature">
          <span className="discord-feature-number" aria-hidden="true">02 / PLAY</span>
          <h2>Make your move</h2>
          <p>
            Explore Murder Mystery Magic, earn POGS and compete for
            progression and house pride with Magical Sorting Bat.
          </p>
        </article>
        <article className="discord-feature">
          <span className="discord-feature-number" aria-hidden="true">03 / CREATE</span>
          <h2>Bring your sound</h2>
          <p>
            Join the voice channels for conversation, music and freestyle
            sessions. Take the mic or kick back with the community.
          </p>
        </article>
      </section>

      <section className="discord-purpose" aria-labelledby="discord-purpose-title">
        <h2 id="discord-purpose-title">Problems 2 Purpose</h2>
        <p>
          An independent community built around participation, creativity
          and shared experiences. Pogforts starts with people. Come and
          be part of it.
        </p>
      </section>
    </div>
  );
}
